// extracted by mini-css-extract-plugin
export default {"main-container":"Layout_main-container__wXIKk"};